import { tns } from 'tiny-slider';

(function (Drupal, once) {

  Drupal.behaviors.eventsTicker = {
    attach: function (context, settings) {
      const tickers = once('events-tickers', '.view-events.view-display-id-events_upcoming_block', context);

      tickers.forEach((tickerWrapper) => {
        const containerEl = tickerWrapper.querySelector('.view-content');

        const ticker = new tns({
          container: containerEl,
          slideBy: "page",
          items: 1,
          autoplay: false,
          gutter: 24,
          autoHeight: true,
          autoplayButtonOutput: false,
          nav: true,
          navPosition: 'bottom',
          controlsText: ['', ''],
          controlsPosition: 'bottom',
          preventScrollOnTouch: 'auto',
          responsive: {
            1500: {
              items: 3
            },
            1000: {
              items: 2
            },
          }
        });
      });
    }
  }

}(Drupal, once));
